import { useContext } from 'react';
import { BlocksContext } from '../../store/blocks.context';

export function useBlocks() {
  const context = useContext(BlocksContext);
  if (!context) throw new Error('useBlocks mus be used within a BlocksProvider');
  return context;
}
